import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../Button';

interface UpdateButtonProps extends ButtonTemplateProps {}

export default function UpdateButton(props: UpdateButtonProps) {
  return (
    <Button {...props} text={props.text || t(TranslationKey.update).singular.upper} variant={ButtonVariant.primary} />
  );
}
